/**
 * Cart Extras — échantillon gratuit + anniversaire.
 * -------------------------------------------------
 * Logique extraite de header-actions (auparavant inline, drawer uniquement) pour fonctionner
 * à la fois dans le drawer ET sur la page /cart. Les valeurs Liquid sont passées par :
 *  - un blob JSON `#cart-extras-config` (coffretProductId) ;
 *  - des data-attributes sur le formulaire anniversaire (messages succès/erreur).
 *
 * Écouteurs délégués sur `document` → survivent aux re-render de section (morph).
 */
(function () {
  if (window.__cartExtrasInit) return;
  window.__cartExtrasInit = true;

  function getConfig() {
    var el = document.getElementById('cart-extras-config');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function getSectionId() {
    var host = document.querySelector('cart-items-component[data-section-id]');
    return host ? host.dataset.sectionId : '';
  }

  // --- Échantillon gratuit : (dé)activer le bouton selon la sélection ---
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.cart-free-sample__select');
    if (!sel) return;
    var row = sel.closest('.cart-free-sample__row');
    var btn = row && row.querySelector('.cart-free-sample__btn');
    if (btn) btn.disabled = sel.value === '';
  });

  // --- Échantillon gratuit : ajout au panier ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-free-sample__btn');
    if (!btn || btn.disabled) return;
    var row = btn.closest('.cart-free-sample__row');
    var sel = row && row.querySelector('.cart-free-sample__select');
    if (!sel || !sel.value) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(sel.value, 10),
        quantity: 1,
        properties: { _is_free_sample: '1' },
        sections: getSectionId()
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: null, sourceId: 'free-sample', data: { sections: data.sections || {} } }
        }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  // --- Échantillon gratuit : retrait auto s'il ne reste plus de produit réel ---
  document.addEventListener('cart:update', function (e) {
    var sourceId = e.detail && e.detail.sourceId;
    if (sourceId === 'free-sample' || sourceId === 'free-sample-remove') return;

    var items = e.detail && e.detail.resource && Array.isArray(e.detail.resource.items)
      ? e.detail.resource.items
      : null;
    if (!items) return;

    var coffretId = getConfig().coffretProductId || 0;
    var freeItem = null;
    var hasNonCoffretItems = false;
    items.forEach(function (item) {
      if (item.properties && item.properties['_is_free_sample'] === '1') {
        freeItem = item;
      } else if (item.product_id !== coffretId) {
        hasNonCoffretItems = true;
      }
    });

    if (!hasNonCoffretItems && freeItem) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeItem.key, quantity: 0, sections: getSectionId() })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: null, sourceId: 'free-sample-remove', data: { sections: data.sections || {} } }
          }));
        });
    }
  });

  // Date du jour (locale) au format YYYY-MM-DD — pour bloquer les dates futures.
  function birthdayTodayStr() {
    var d = new Date();
    var m = String(d.getMonth() + 1);
    if (m.length < 2) m = '0' + m;
    var day = String(d.getDate());
    if (day.length < 2) day = '0' + day;
    return d.getFullYear() + '-' + m + '-' + day;
  }
  function birthdayIsFuture(value) {
    return !!value && value > birthdayTodayStr();
  }

  // --- Anniversaire : ouvrir le sélecteur de date dès le clic sur le champ ---
  document.addEventListener('click', function (e) {
    var input = e.target.closest && e.target.closest('#cart-birthday-input');
    if (!input || typeof input.showPicker !== 'function') return;
    try {
      input.showPicker();
    } catch (err) {
      /* showPicker peut lever si déjà ouvert / non autorisé — sans conséquence */
    }
  });

  // --- Anniversaire : (dé)activer le bouton selon la date (jamais de date future) ---
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('#cart-birthday-input');
    if (!input) return;
    var btn = document.getElementById('cart-birthday-btn');
    if (btn) btn.disabled = input.value === '' || birthdayIsFuture(input.value);
  });

  // --- Anniversaire : enregistrement (attribut de panier `birthday`) ---
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('#cart-birthday-form');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('#cart-birthday-input');
    var hidden = form.querySelector('#cart-birthday-hidden');
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('#cart-birthday-message');
    if (!input || !input.value) return;

    // Sécurité : on refuse une date future (le bouton est normalement déjà désactivé).
    if (birthdayIsFuture(input.value)) {
      if (msg) msg.textContent = form.dataset.futureMessage || form.dataset.errorMessage || '';
      return;
    }

    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    if (msg) msg.textContent = '';
    if (hidden) hidden.value = input.value;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { birthday: input.value } })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        if (msg) {
          msg.textContent = form.dataset.successMessage || '';
          setTimeout(function () { if (msg) msg.textContent = ''; }, 3000);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        if (msg) msg.textContent = form.dataset.errorMessage || '';
      });
  });
})();
